module.exports = __webpack_public_path__ + "static/media/small_mclaren.885f3d41.png";